import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { usePage } from "../../context/PageContext";
import TextBlock from "../blocks/TextBlock";
import ImageBlock from "../blocks/ImageBlock";
import HeaderBlock from "../blocks/HeaderBlock";
import MarkdownBlock from "../blocks/MarkdownBlock";

const BlockWrapper = ({ block }) => {
  const { updateBlock, deleteBlock, mode } = usePage();

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: block.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const renderBlock = () => {
    switch (block.type) {
      case "text":
        return <TextBlock data={block.data} update={(d) => updateBlock(block.id, d)} mode={mode} />;
      case "image":
        return <ImageBlock data={block.data} update={(d) => updateBlock(block.id, d)} mode={mode} />;
      case "header":
        return <HeaderBlock data={block.data} update={(d) => updateBlock(block.id, d)} mode={mode} />;
      case "markdown":
        return <MarkdownBlock data={block.data} update={(d) => updateBlock(block.id, d)} mode={mode} />;
      default:
        return null;
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`block-shell block-shell--${block.type}`}
    >
      {mode === "edit" && (
        <>
          <div className="block-drag" {...attributes} {...listeners}>
            <span className="block-drag-icon" aria-hidden="true">
              {"\u22EE\u22EE"}
            </span>
            <span>Drag to reorder</span>
          </div>

          <button
            type="button"
            className="block-delete"
            onClick={() => deleteBlock(block.id)}
            title="Remove block"
            aria-label="Remove block"
          >
            ×
          </button>
        </>
      )}

      {renderBlock()}
    </div>
  );
};

export default BlockWrapper;
